import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { getCurrentAllotments, getFutureAllotments } from '../../gamedayAccount/selectors';
import { newAllotmentTypes } from '../../types/allotments';

const DepartmentHeader = ({ currentContractPeriod, futureContractPeriod, currentAllotments, futureAllotments }) => {
  const theFutureIsNow = currentAllotments === futureAllotments;

  return (
    <div className='departmentSelect__header prl7-md'>
      <div className='d-sm-h d-md-ib'>
        <div className='body-4 u-bold'>
          <TranslatedCopy id='shop.deptSelect.table.department.title' />
        </div>
      </div>
      <div className='departmentSelect__headerRemaining'>
        <div className='pl2-md'>
          <div className='body-4'>
            <div className='d-md-ib u-bold text-underline'>
              <TranslatedCopy id='shop.deptSelect.table.current.title' />
            </div>
            <div>{currentContractPeriod}</div>
          </div>
        </div>
        <div className='pl2-sm pl0-md'>
          <div className='body-4'>
            <div className='d-md-ib u-bold text-underline'>
              {theFutureIsNow ? (
                <TranslatedCopy id='shop.deptSelect.table.current.title' />
              ) : (
                <TranslatedCopy id='shop.deptSelect.table.futures.title' />
              )}
            </div>
            <div>{futureContractPeriod}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

DepartmentHeader.defaultProps = {
  currentContractPeriod: null,
  futureContractPeriod: null
};

DepartmentHeader.propTypes = {
  currentContractPeriod: PropTypes.string,
  futureContractPeriod: PropTypes.string,
  currentAllotments: newAllotmentTypes.isRequired,
  futureAllotments: newAllotmentTypes.isRequired
};

const mapStateToProps = state => ({
  currentAllotments: getCurrentAllotments(state),
  futureAllotments: getFutureAllotments(state)
});

export default connect(mapStateToProps, {})(DepartmentHeader);
